/* eslint no-console: 0, no-underscore-dangle: 0 */
import { isStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { RelatedKeywordsPodStyles } from './RelatedKeywordsPod.style';

const RelatedKeywordsPod = ({ keyword, totalKeywords, currentKeywordPosition, searchTerm, appCtx }) => {
  const [relatedKeywordSearchUrl, setRelatedKeywordSearchUrl] = useState('');
  const store = appCtx?.store;
  useEffect(() => {
    if (keyword) {
      const { host, pathname } = window.location;
      if (/\/(shop|b)\//.test(pathname)) {
        const segments = pathname.split('/');
        segments.pop();
        let newPathname = segments.join('/');
        newPathname = newPathname.replace(/\/(shop|b)\b/g, isStandalone({ store }) ? '/buscar' : '/search');
        setRelatedKeywordSearchUrl(`https://${host + newPathname}?Ntt=${keyword}`);
      } else {
        setRelatedKeywordSearchUrl(`https://${host + pathname}?Ntt=${keyword}`);
      }
    }
  }, [keyword]);

  const handleKeywordClick = () => {
    if (window._satellite) {
      window._satellite.setVar(
        'Related_Keyword_Use',
        `${searchTerm} | ${keyword} | ${currentKeywordPosition} | ${totalKeywords}`
      );
    }
    const eventToDigitalData = new CustomEvent('DDXLPRelatedKeywordClick', {
      bubbles: true,
      detail: {
        payload: `${searchTerm} | ${keyword} | ${currentKeywordPosition} | ${totalKeywords}`,
      },
    });
    window.dispatchEvent(eventToDigitalData);
  };

  if (!keyword) {
    return null;
  }

  return (
    <a
      id={`related-keyword-pod-${currentKeywordPosition}`}
      key={`related-keyword-pod-${currentKeywordPosition}`}
      href={relatedKeywordSearchUrl}
      onClick={handleKeywordClick}
      className="related-keyword-pod"
    >
      <i className="related-keyword-pod-icon" />
      <span className="related-keyword-pod-text">{keyword}</span>
      <style jsx>{RelatedKeywordsPodStyles}</style>
    </a>
  );
};

RelatedKeywordsPod.propTypes = {
  keyword: PropTypes.string.isRequired,
  totalKeywords: PropTypes.number.isRequired,
  currentKeywordPosition: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export default withApplicationContext(RelatedKeywordsPod);
export { RelatedKeywordsPod };
